import { RefreshCw } from "lucide-react";
import { LGoBadge, LGoButton, LGoCard, LGoCardHeader, LGoCardTitle } from "@/ui/branded";
import { unavailableCopy } from "./payment-account-copy";

export interface PaymentAccountUnavailableNoticeProps {
  onRetry?: () => void;
  /** The API's own sentence when it wrote one. It says which read failed and
   *  what to do about it, which the generic copy cannot. */
  reason?: string | null;
}

/** The section's frame for a read that failed outright, so the partner sees
 *  which part of the page did not answer. No Stripe button: a link offered on
 *  an unknown account promises something the portal cannot vouch for. */
export function PaymentAccountUnavailableNotice({
  onRetry,
  reason,
}: PaymentAccountUnavailableNoticeProps) {
  return (
    <LGoCard variant="raised" role="alert">
      <LGoCardHeader>
        <div className="flex items-center gap-3">
          <LGoCardTitle>Platby a výplaty</LGoCardTitle>
          <LGoBadge variant={unavailableCopy.badgeVariant}>{unavailableCopy.badge}</LGoBadge>
        </div>
      </LGoCardHeader>

      <h3 className="font-display text-xl font-semibold tracking-tight">{unavailableCopy.title}</h3>
      <p className="mt-2 text-sm text-muted-foreground max-w-prose">
        {reason ?? unavailableCopy.body}
      </p>

      {onRetry && (
        <div className="mt-5">
          <LGoButton variant="secondary" onClick={onRetry} iconLeft={<RefreshCw />}>
            Zkusit znovu
          </LGoButton>
        </div>
      )}
    </LGoCard>
  );
}
